import firebase from "firebase/compat/app";
import "firebase/compat/app";
import "firebase/compat/auth";
import "./firebaseConfig";
import store from "@/store/index";
import router from "@/router/index";
import axios from "./axios";
import VueJwtDecode from "vue-jwt-decode";

export const getUser = () => {
  firebase.auth().onAuthStateChanged(async (user) => {
    try {
      if (user) {
        const token = await user?.getIdToken?.();
        const tokenData = VueJwtDecode.decode(token);

        const UserdbData = await axios.get("/users/" + tokenData.sqlUID);
        const plan = await axios({
          url: "/membership",
          method: "get",
          headers: {
            Authorization: "Bearer " + token,
          },
        });

        const userData = {
          ...tokenData,
          ...UserdbData.data,
          email: user.email,
          photoURL: user.photoURL,
          phoneNumber: user.phoneNumber,
          stripeId: UserdbData.stripeId || "",
          displayName: user.displayName,
          uid: user.uid,
          plan: plan?.data?.plan,
          plan_rules: plan?.data?.plan_rules,
        };

        store.dispatch({
          type: "updateUser",
          user: userData,
        });
        if (localStorage.getItem("goBackTo")) {
          const goBackTo = localStorage.getItem("goBackTo");
          localStorage.removeItem("goBackTo");
          router.push(goBackTo);
        }
      } else {
        store.dispatch("clearAuth");
      }
    } catch (error) {
      console.log(error);
    } finally {
      store.dispatch("initing");
    }
  });
};

export const logout = () => {
  return new Promise((resolve, reject) => {
    firebase
      .auth()
      .signOut()
      .then(() => {
        store.dispatch("clearAuth");
        resolve();
      })
      .catch((error) => {
        reject(error);
      });
  });
};
